import { render, staticRenderFns } from "./CommentMentionBar.vue?vue&type=template&id=75d983ef&"
import script from "./CommentMentionBar.vue?vue&type=script&lang=js&"
export * from "./CommentMentionBar.vue?vue&type=script&lang=js&"
import style0 from "./CommentMentionBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VList,VProgressCircular})
